var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 16.1667C1.83301 16.5931 1.99576 17.0198 2.32126 17.3448C2.97226 17.9958 4.02688 17.9958 4.67788 17.3448L11.8324 10.1879L18.9881 17.3448C19.6391 17.9958 20.6938 17.9958 21.3448 17.3448C21.9958 16.6938 21.9958 15.6391 21.3448 14.9881L13.012 6.65535C12.361 6.00435 11.3063 6.00435 10.6554 6.65535L2.32256 14.9881C1.99446 15.3136 1.83301 15.7402 1.83301 16.1667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleUp);
export default __webpack_public_path__ + "static/media/angle-up.85fce629dd6fdf6ff84f5dbafbb80f4a.svg";
export { ForwardRef as ReactComponent };